// extracted by mini-css-extract-plugin
module.exports = {"success":"HistoryItem_success__FMBRw","error":"HistoryItem_error__Burom","icon":"HistoryItem_icon__pLyYZ"};